import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-super-code',
  template: `
    <p>
      super-code works!
    </p>
  `,
  styles: [
  ]
})
export class SuperCodeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
